import { useCallback, useEffect, useRef } from "react";
import { setIndex } from "../../store/actions/abPlayerStore";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetFooterPlayerRef } from "./useGetFooterPlayerRef";

/**
 * @description Append an event listener after creation of the waveform via WaveSurfer events.
 * The event listener will be triggered when the track is finished playing.
 * Because finish event is dynamic, it will be reset and set when dependencies change.
 */
export const useSetupOnFinish = (isLooping: boolean) => {
  const dispatch = useAppDispatch();
  const footerRef = useGetFooterPlayerRef();
  const { playlist, currentTrackIndex } = useAppSelector(
    (state) => state.abPlayerStore,
  );
  const disableOnFinish = useRef<(() => void) | null>(null);

  const useLoopTrack = useCallback(() => {
    if (!footerRef) return;
    if (isLooping) {
      footerRef.currentTime = 0;
      if (footerRef.paused) footerRef.play().catch(() => {});
    } else if (playlist.length > 1) {
      footerRef.pause();
      dispatch(setIndex(currentTrackIndex + 1));
    }
  }, [footerRef, isLooping, playlist.length, dispatch, currentTrackIndex]);

  useEffect(() => {
    if (!footerRef) return;
    disableOnFinish.current?.();
    footerRef.onended = useLoopTrack;
    // disableOnFinish.current = footerRef on("finish", useLoopTrack);
  }, [footerRef, useLoopTrack]);
};
